import { newareasList,areasList, getWxJsApi } from "@/api";
import baseHousePic from "@/assets/allpngno.png";
import jsonp from "jsonp";

export const CUSTOMER_VIEW_TOKEN = "7s9G2kF8dS1pX5rB0qL4jN6mC3tV7aZ";
export const CUSTOMER_VIEW_STATION_KEY = "jinhua";

export function isCustomerViewToken(token) {
    const current = token ?? localStorage.getItem("token");
    return current === CUSTOMER_VIEW_TOKEN;
}

export const getWebUrl = () =>
    window.location.protocol +
    "//" +
    window.location.host +
    window.location.search;

export async function wxConfig() {
    let url = window.location.href;
    let { data } = await getWxJsApi(url).catch((e) => e);

    return new Promise((resolve, reject) => {
        if (data && data.code == 0) {
            let { data: wxData } = data;
            wx.config({
                debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
                appId: wxData.appId, // 必填，公众号的唯一标识
                timestamp: wxData.timestamp, // 必填，生成签名的时间戳
                nonceStr: wxData.nonceStr, // 必填，生成签名的随机串
                signature: wxData.signature, // 必填，签名
                jsApiList: [
                    "chooseImage",
                    "getLocalImgData",
                    "chooseWXPay",
                    "updateAppMessageShareData",
                    "updateTimelineShareData",
                    "onMenuShareTimeline",
                    "onMenuShareAppMessage",
                    "onMenuShareQQ",
                    "onMenuShareQZone",
                ], // 必填，需要使用的 JS 接口列表
            });

            wx.ready(function () {
                resolve();
            });

            wx.error(function (res) {
                reject(res);
            });
            // wx.checkJsApi(
            // 	{
            // 		jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'], // 需要检测的 JS 接口列表，所有 JS 接口列表见附录2,
            // 		success: function (res) {
            // 			// 以键值对的形式返回，可用的 api 值true，不可用为false
            // 			// 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            // 			console.log(res);
            // 		}
            // 	});
        } else {
            reject(new Error("签名错误!"));
        }
    });
}

/**
 *
 * @param {Array} arr
 * @param {String} key
 */
export function getAttr(arr, key) {
    let find = arr.find((v) => v.key == key);
    return find ? find.value : "";
}

export function get_floor_type(floor, total_floor) {
    if (floor === "" || floor == null || total_floor === "" || total_floor == null) {
        return "";
    }

    floor = Number(floor);
    total_floor = Number(total_floor);

    if (total_floor < 1 || floor <= 0) {
        return "低楼层";
    }
    if (floor > total_floor) {
        return "";
    }
    let spec = find_specification(total_floor, specs);
    if (spec.isLow(floor, total_floor)) {
        return "低楼层";
    }
    if (spec.isHigh(floor, total_floor)) {
        return "高楼层";
    }
    return "中楼层";
}

const HIDE_DOORPLATE_STORAGE_KEY = "hideDoorplate";

/** 从 App webview 传入的 query 计算并持久化是否隐藏门牌 */
export function initDoorplateHideFromQuery(query = {}) {
    // 仅在 App 显式传了隐藏相关参数时写入；strip 后只剩 stationKey=jinhua 时不要覆盖缓存
    const hasExplicitFlag =
        query.hideDoorplate != null ||
        query.liveMode != null ||
        query.quzhou != null;
    const isQuzhouStation =
        String(query.stationKey || "").toLowerCase() === "quzhou";
    if (!hasExplicitFlag && !isQuzhouStation) {
        return localStorage.getItem(HIDE_DOORPLATE_STORAGE_KEY) === "1";
    }
    const hide = shouldHideDoorplateFromQuery(query);
    localStorage.setItem(HIDE_DOORPLATE_STORAGE_KEY, hide ? "1" : "0");
    return hide;
}

function shouldHideDoorplateFromQuery(query = {}) {
    if (String(query.hideDoorplate) === "1") return true;
    if (String(query.liveMode) === "1") return true;
    if (String(query.quzhou) === "1") return true;
    if (String(query.stationKey || "").toLowerCase() === "quzhou") return true;
    return false;
}

/** 是否隐藏楼栋/单元/房号及具体楼层号（优先读传入 query，否则读本地缓存） */
export function shouldHideDoorplate(query) {
    if (query && typeof query === "object") {
        const hasExplicitFlag =
            query.hideDoorplate != null ||
            query.liveMode != null ||
            query.quzhou != null;
        const isQuzhouStation =
            String(query.stationKey || "").toLowerCase() === "quzhou";
        if (hasExplicitFlag || isQuzhouStation) {
            return shouldHideDoorplateFromQuery(query);
        }
    }
    return localStorage.getItem(HIDE_DOORPLATE_STORAGE_KEY) === "1";
}

/** obj: { building, unit, room }。隐藏时返回 "" */
export function formatDoorplate(obj, opts = {}) {
    const { separator = "", fallback = "", query } = opts;
    if (shouldHideDoorplate(query)) return "";
    if (!obj) return fallback;
    const parts = [obj.building, obj.unit, obj.room].filter(
        (x) => x !== undefined && x !== null && String(x).trim() !== ""
    );
    return parts.length ? parts.join(separator) : fallback;
}

/**
 * 楼层文案：正常「中楼层/16/25层」，隐藏门牌时「中楼层/25层」（去掉中间具体层号）
 */
export function formatFloorLine(obj, opts = {}) {
    if (!obj) return "";
    const { query } = opts;
    const type = get_floor_type(obj.floor, obj.totalFloors);
    const floor = obj.floor;
    const total = obj.totalFloors;
    const hasTotal = total !== undefined && total !== null && String(total).trim() !== "";
    const hasFloor = floor !== undefined && floor !== null && String(floor).trim() !== "";

    if (shouldHideDoorplate(query)) {
        if (type && hasTotal) return `${type}/${total}层`;
        return type || "";
    }
    if (type && hasFloor && hasTotal) return `${type}/${floor}/${total}层`;
    return type || "";
}

var specs = [
    {
        min: 0,
        max: 4,
        isLow: function (floor, total_floor) {
            return true;
        },
        isHigh: function (floor, total_floor) {
            return false;
        },
    },
    {
        min: 5,
        max: 7,
        isLow: function (floor, total_floor) {
            return floor <= 1;
        },
        isHigh: function (floor, total_floor) {
            return floor >= 5;
        },
    },
    {
        min: 8,
        max: 12,
        isLow: function (floor, total_floor) {
            return floor <= 2;
        },
        isHigh: function (floor, total_floor) {
            return floor > total_floor - 3;
        },
    },
    {
        min: 13,
        max: 20,
        isLow: function (floor, total_floor) {
            return floor <= 3;
        },
        isHigh: function (floor, total_floor) {
            return floor > total_floor - 4;
        },
    },
    {
        min: 20,
        max: 999,
        isLow: function (floor, total_floor) {
            return floor <= 4;
        },
        isHigh: function (floor, total_floor) {
            return floor > total_floor - 5;
        },
    },
];

function find_specification(floor) {
    for (let i = 0; i < specs.length; ++i) {
        let spec = specs[i];
        if (floor >= spec.min && floor <= spec.max) {
            return spec;
        }
    }
    throw "无效的楼层";
}

export async function getAreaList() {
    const obj = {
        id: null,
        parentId: "7001052398193999872",
        name: "市本级",
        position: 100,
        children: [],
        stationKey: isCustomerViewToken()
            ? CUSTOMER_VIEW_STATION_KEY
            : localStorage.getItem("stationKey"),
    };
    let allCityRes;
    if (isCustomerViewToken()) {
        allCityRes = await newareasList("true", {
            stationKey: CUSTOMER_VIEW_STATION_KEY,
        });
    } else if (!localStorage.getItem("isnew")) {
        allCityRes = await areasList("true");
    } else {
        allCityRes = await newareasList("true");
    }

    const allCity = allCityRes?.data?.data;
    if (!Array.isArray(allCity)) {
        return obj;
    }

    for (let i = 0; i < allCity.length; i++) {
        if (
            allCity[i].parentId == obj.id &&
            allCity[i].stationKey == obj.stationKey
        ) {
            const childrenobj = {
                ...allCity[i],
                children: [],
            };
            allCity.forEach((element) => {
                if (childrenobj.id == element.parentId) {
                    childrenobj.children.push(element);
                }
            });
            obj.children.push(childrenobj);
        }
    }
    return obj;
}

const DEFAULT_HOUSE_IMAGE =
    "https://fangtuoyun.oss-cn-hangzhou.aliyuncs.com/79651e13-2a97-488f-b9ba-f8e0ee2fae87";

export function ensureArray(value) {
    if (Array.isArray(value)) return value;
    if (value == null || value === "") return [];
    return [value];
}

export function getImages(row) {
    const images = row?.images;
    if (Array.isArray(images) && images.length) {
        return images.map((v) => (typeof v === "string" ? v : v.url));
    }
    const imageUrls = row?.community?.imageUrls;
    if (Array.isArray(imageUrls) && imageUrls.length) {
        return imageUrls;
    }
    return [DEFAULT_HOUSE_IMAGE];
}

export const salesSortOptions = [
    { label: "默认排序", value: "" },
    { label: "单价由低到高", value: "sellingAveragePrice:asc" },
    { label: "单价由高到低", value: "sellingAveragePrice:desc" },
    { label: "总价由低到高", value: "sellingPrice:asc" },
    { label: "总价由高到低", value: "sellingPrice:desc" },
];

export const rentSortOptions = [
    { label: "默认排序", value: "" },
    { label: "租金由低到高", value: "rent:asc" },
    { label: "租金由高到低", value: "rent:desc" },
];

export function getSortLabel(type, orderBy) {
    if (!orderBy) return "排序";
    const source = type === "sales" ? salesSortOptions : rentSortOptions;
    return source.find((item) => item.value === orderBy)?.label || "排序";
}

/**
 * 设置缓存
 * @param {*} key
 * @param {*} value
 * @returns
 */
export function setCache(key, value) {
    localStorage.setItem(key, JSON.stringify({ data: value }));
    return true;
}

/**
 * 读取缓存
 * @param {*} key
 * @returns
 */
export function getCache(key, defaultValue = "") {
    let v = localStorage.getItem(key);
    if (v) {
        return JSON.parse(v).data;
    }
    return defaultValue;
}
/**
 * 清空缓存
 * @param {*} key
 */
export function removeCache(key = "") {
    if (key == "") {
        localStorage.clear();
    } else {
        localStorage.removeItem(key);
    }
}

export function getqueryproperties(properties) {
    //计算户型
    let str = "";
    if (properties.rooms.length) {
        str += getRoomspro(properties.rooms);
    }
    delete properties.rooms;

    for (let key in properties) {
        if (typeof properties[key] == "string") {
            if (properties[key]) {
                str += key + ":" + properties[key] + ";";
            }
        } else {
            if (properties[key].length) {
                str += key + ":" + properties[key].join(",") + ";";
            }
        }
    }

    return str;
}

function getRoomspro(rooms) {
    let arr = [];
    if (rooms.indexOf("1室") !== -1) {
        arr.push("1,1");
    }
    if (rooms.indexOf("2室") !== -1) {
        arr.push("2,2");
    }
    if (rooms.indexOf("3室") !== -1) {
        arr.push("3,3");
    }
    if (rooms.indexOf("4室") !== -1) {
        arr.push("4,4");
    }
    if (rooms.indexOf("4室以上") !== -1) {
        arr.push("5,");
    }

    return "rooms:" + arr.join(":") + ";";
}

/**
 * 朝向
 */
export const directionList = ["东", "南", "西", "北", "南北", "东西"];

/**
 * 装修
 */
export const decorateList = ["豪装", "精装", "中装", "简装", "毛胚"];

/**
 * 电梯
 */
export const ladderList = ["有", "无"];
/**
 * 车库列表
 */
export const garageList = [
    "车位（不上证）",
    "车库（地上）",
    "车库（地下）",
    "辅房",
    "辅房（不上证）",
    "无",
];

/**
 * 获取周边配套数据
 * @param {*} category
 * @param {*} lat
 * @param {*} lon
 * @returns {Promise<Array>}
 */
export function getAmbitusByCategory(category, lat, lon) {
    // return new Promise((resolve, reject) =>
    // {
    //     uni.request(
    //     {
    //         url: "https://apis.map.qq.com/ws/place/v1/search",
    //         data:
    //         {
    //             boundary: `nearby(${lat},${lon},1000,0)`,
    //             key: '33ZBZ-EOK33-FAI3T-YRKGJ-BHZDF-KWFUO',
    //             output: 'JSON',
    //             keyword: '金华',
    //             filter: 'category=' + category,
    //             page_size: 20
    //         },
    //         method: "GET",
    //         success: ({ data: res }) =>
    //         {
    //             if (res.status == 0)
    //             {
    //                 res.data.sort((a, b) =>
    //                 {
    //                     return a._distance - b._distance
    //                 })
    //                 resolve(res.data)
    //             }
    //         },
    //         fail: () =>
    //         {
    //             reject(1)
    //         }
    //     })
    // })
    return new Promise((resolve, reject) => {
        let v = objectToQuery({
            boundary: `nearby(${lat},${lon},1000,0)`,
            key: "33ZBZ-EOK33-FAI3T-YRKGJ-BHZDF-KWFUO",
            output: "jsonp",
            keyword: "金华",
            filter: "category=" + category,
            page_size: 20,
        });
        let r = jsonp(
            "https://apis.map.qq.com/ws/place/v1/search",
            {
                param: v + "&callback",
                name: "a110",
                timeout: 100000,
                //prefix: '&callback'
            },
            (err, res) => {
                console.log(110);
                if (!err) {
                    res.data.sort((a, b) => {
                        return a._distance - b._distance;
                    });
                    resolve(res.data);
                } else {
                    reject(err);
                }
            }
        );
    });
}

function objectToQuery() {
    let obj = arguments[0];
    let prefix = arguments[1];
    if (typeof obj !== "object") return "";
    const attrs = Object.keys(obj);
    return attrs.reduce((query, attr, index) => {
        // 判断是否是第一层第一个循环
        if (index == 0 && !prefix) query += "";
        if (typeof obj[attr] == "object") {
            const subPrefix = prefix ? `${prefix}.${attr}` : attr;
            query += this.objectToQuery(obj[attr], subPrefix);
        } else {
            if (prefix) {
                query += `${prefix}.${attr}=${obj[attr]}`;
            } else {
                query += `${attr}=${obj[attr]}`;
            }
        }
        // 判断是否是第一层最后一个循环
        if (index !== attrs.length - 1) query += "&";
        return query;
    }, "");
}

/**
 * 将base64图片数据转成file对象
 * @param {*} dataurl
 * @returns
 */
export function dataURLtoFile(dataurl, name) {
    console.log(dataurl);
    let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], name, { type: mime });
}

//1,先将base64转换为blob
export function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}

//2,再将blob转换为file
export function blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date(); // 文件最后的修改日期
    theBlob.name = fileName; // 文件名
    return new File([theBlob], fileName, {
        type: theBlob.type,
        lastModified: Date.now(),
    });
}
